module.exports = __webpack_public_path__ + "../resources/img/bg_storage1_01.d87eb5a6.png";